import { useMemo } from "react";
import { Plus } from "lucide-react";
import { Link } from "react-router-dom";
import MultiSelect from "@/components/common/MultiSelect";

// Audience picker shared by the standard and popunder flows: a campaign
// targets the union of its segments (ANY match); none ⇒ everyone.
export default function SegmentPicker({ segments, value, onChange }) {
  const options = useMemo(
    () =>
      segments
        .map((segment) => ({ value: segment.uuid, label: segment.name }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [segments],
  );

  if (options.length === 0) {
    return (
      <p className="form-help-text">
        No audiences available yet.{" "}
        <Link
          to="/dashboard/segments/new"
          className="font-medium text-(--brand-primary) hover:underline"
        >
          <Plus size={12} strokeWidth={2.5} className="inline" /> Create an
          audience
        </Link>{" "}
        first to target it.
      </p>
    );
  }
  return (
    <MultiSelect
      options={options}
      value={value}
      onChange={onChange}
      placeholder="Search audiences..."
    />
  );
}
